import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { CookieService } from 'ngx-cookie-service';
import { COOKIE_POLICY_KEY } from '../../../constants/cookie';
import { createSelector, select, Store } from '@ngrx/store';
import { AppSettingReducerType } from '../../../store/reducers/app-setting.reducer';
import { Subscription } from 'rxjs';
import { ActionReducerMapType } from '../../../store/config-reducers';

const selectReducer = (state: ActionReducerMapType) => {
    return state;
};

const selectAppSettingReducer = createSelector(selectReducer, (state) => {
    return state.appSettingReducer;
});

@Component({
    selector: 'app-cookie',
    templateUrl: './cookie.component.html',
    styleUrls: ['./cookie.component.scss'],
})
export class CookieComponent implements OnInit {
    alreadyAction = false;
    isDesktop = true;
    appSettingTextSizeClass: AppSettingReducerType['textSizeInfo']['class'];
    subscriptions: Array<Subscription> = [];

    constructor(
        private cookieService: CookieService,
        private platForm: Platform,
        private store: Store<ActionReducerMapType>
    ) {
        const subscribeAppSettingReducer = this.store
            .pipe(select(selectAppSettingReducer))
            .subscribe((state) => {
                this.appSettingTextSizeClass = state.textSizeInfo.class;
            });
        this.subscriptions.push(subscribeAppSettingReducer);

        this.setIsAlreadyAction();
    }

    ngOnInit() {}

    ngDoCheck() {
        this.isDesktop = this.platForm.is('desktop');
    }

    onAccept() {
        const cookieJSON = {
            accept: true,
        };
        const cookieString = JSON.stringify(cookieJSON);
        this.cookieService.set(COOKIE_POLICY_KEY, cookieString, 365);
        this.alreadyAction = true;
    }

    onReject() {
        const cookieJSON = {
            accept: false,
        };
        const cookieString = JSON.stringify(cookieJSON);
        this.cookieService.set(COOKIE_POLICY_KEY, cookieString);
        this.alreadyAction = true;
    }

    setIsAlreadyAction() {
        const jsonString = this.cookieService.get(COOKIE_POLICY_KEY);
        if (jsonString && jsonString !== '') {
            const parseJson = JSON.parse(jsonString);
            const isAccept = parseJson?.accept ?? false;
            if (isAccept) {
                this.alreadyAction = true;
            }
        }
    }
}
